import { IRole } from 'shared/models/api/models';
import useSelector from "./useSelector";

export interface IRoles {
    roles: string[],
    isBOH: boolean
}

export const userHasPermission = (permission?: string | null, userRoles?: IRole[]) => {
    if (!permission || permission.length === 0) return true;

    if (!userRoles) {
        userRoles = useUserRoles();
    }

    return userRoles.some(role => role.permissions.includes(permission));
};

export const userHasAnyRequiredRole = (requiredRoles: string[], userRoles?: IRole[]) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;

    if (!userRoles) {
        userRoles = useUserRoles();
    }

    return userRoles.some(userRole => requiredRoles.includes(userRole.name));
};

export const useIsBackOfHouse = (): boolean => useSelector(s => s.isBackOfHouseUser);

export const useProfile = () => {
    return useSelector(s => s.profile);
};

export const useUserRoles = (): IRole[] => {
    var usr = useSelector(s => s.profile);    

    return usr?.roles ?? [];
};

// maintaining this method for exisiting code, but propbably should be using something else to get the BOH
const useRoles = (): IRoles => {
    var usr = useSelector(s => s.profile);

    return {
        roles: usr?.roles.map(role => role.name) ?? [],
        isBOH: usr?.roles.some(role => role.isBackOfHouseRole === true) ?? false
    };
};

export default useRoles;
